import { render, staticRenderFns } from "./UserStatsCards.vue?vue&type=template&id=7e7fd5bd&scoped=true&"
import script from "./UserStatsCards.vue?vue&type=script&lang=js&"
export * from "./UserStatsCards.vue?vue&type=script&lang=js&"
import style0 from "./UserStatsCards.vue?vue&type=style&index=0&id=7e7fd5bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7fd5bd",
  null
  
)

export default component.exports